import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

import UserOption from "./UserOption";
import { getCookie } from "../utility/Cookie";

import logo from "../assets/LogoS.png";

const Header = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const TOKEN = getCookie("_t_");

  return (
    <div className="header fixed-top">
      <div className="container header-container">
        <Link to="/" className="logo">
          <img src={logo} alt="logo" />
        </Link>

        <div className="menu-icon" onClick={handleClick}>
          <i className={click ? "fas fa-times" : "fas fa-bars"} />
        </div>

        <ul className={click ? "active" : ""}>
          <li className="lineAfterLogo" />
          <li className="navItem">
            <NavLink to="/courses" onClick={handleClick}>
              Courses
            </NavLink>
          </li>
          <li className="navItem">
            <NavLink to="/reading" onClick={handleClick}>
              Reading
            </NavLink>
          </li>
          <li className="navItem">
            <NavLink to="/pricing" onClick={handleClick}>
              Pricing
            </NavLink>
          </li>
          <li className="navItem">
            <NavLink to="/contact" onClick={handleClick}>
              Contact
            </NavLink>
          </li>
          <li className="navItem">
            <NavLink to="/about" onClick={handleClick}>
              About
            </NavLink>
          </li>
          {TOKEN ? (
            <UserOption />
          ) : (
            <li className="buttons nav-right">
              <Link to="/login" className="btn but1" onClick={handleClick}>
                Login
              </Link>
              <Link to="/register" className="btn but2" onClick={handleClick}>
                Register
              </Link>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default Header;
